import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=42cb3556&scoped=true"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./activity.vue?vue&type=style&index=1&id=42cb3556&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb3556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42cb3556')) {
      api.createRecord('42cb3556', component.options)
    } else {
      api.reload('42cb3556', component.options)
    }
    module.hot.accept("./activity.vue?vue&type=template&id=42cb3556&scoped=true", function () {
      api.rerender('42cb3556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/wedding/activity.vue"
export default component.exports